import { SxProps, Theme, TypographyProps } from '@mui/material';

/** Standard Paper elevation for all data tables */
export const TABLE_PAPER_ELEVATION = 0;

/**
 * Standard Paper sx prop for all data tables.
 * Applies consistent header, toolbar, and cell styling matching the Portfolio Detailed view.
 */
export const TABLE_PAPER_SX: SxProps<Theme> = {
  marginBottom: '40px',
  '& .MUIDataTableToolbar-root': {
    minHeight: '40px !important',
    padding: '4px 8px !important',
    display: 'flex !important',
    alignItems: 'center !important',
  },
  '& .MuiTableCell-head': {
    padding: '10px 8px !important',
    fontSize: '14px !important',
    fontFamily: 'AvenirMedium !important',
    backgroundColor: '#CACACA !important',
    color: 'black !important',
    fontWeight: 400,
  },
  '& .MUIDataTableHeadCell-root': {
    padding: '4px 8px !important',
  },
  '& .MuiToolbar-root': {
    minHeight: '40px !important',
    padding: '4px 8px !important',
  },
};

/**
 * Standard setRowProps function for MUI DataTable rows.
 * Returns alternating row backgrounds matching the Portfolio Detailed view.
 * Usage: setRowProps: getTableRowProps
 */
export function getTableRowProps(_row: unknown, _dataIndex: number, rowIndex: number) {
  return {
    style: {
      backgroundColor: rowIndex % 2 === 0 ? '#E9E9E9' : '#F4F4F4',
    },
    sx: {
      '& td, & th': {
        padding: '8px 8px',
      },
    },
  };
}

/**
 * Returns sx props for expandable detail rows with alternating colors.
 * Matches the Portfolio Detailed view pattern.
 */
export function getDetailRowSx(index: number): SxProps<Theme> {
  return {
    '& td': {
      padding: '8px 8px',
    },
    ':hover': {
      backgroundColor: '#ece5fe',
    },
    backgroundColor: index % 2 === 0 ? '#FAFAFA' : '#F4F4F4',
  };
}

/**
 * Returns a consistent MUI Typography color prop based on a numeric value.
 * - Zero/null/undefined - 'textPrimary'
 * - Negative - 'error'
 * - Positive - 'secondary'
 */
export function getValueColor(value: number | null | undefined): TypographyProps['color'] {
  if (!value) return 'textPrimary';
  return value < 0 ? 'error' : 'secondary';
}
